import { useContext } from 'react';
import { Context } from '../Provider';

const usePageInfoUpdater = () => {
  const context = useContext(Context);
  return context.updatePageInfo;
};

export default usePageInfoUpdater;
